type CalendarSyncIssueCode = 'CALENDAR_NOT_CONNECTED' | 'CALENDAR_SYNC_FAILED';

type CalendarSyncIssue = {
  code: CalendarSyncIssueCode;
  message: string;
};

type CalendarSyncIssueHandlerOptions = {
  onMessage?: (message: string) => void;
  onNotConnected?: () => void | Promise<void>;
};

type BackendResponse = {
  status?: number;
  body?: {
    status_code?: number;
    message?: string;
    detail?: string;
  };
  isError?: boolean;
};

const NOT_CONNECTED_MESSAGE = 'Google Calendar is not connected. Please connect your calendar again to continue.';
const SYNC_FAILED_MESSAGE = 'Unable to sync with Google Calendar. Please reconnect your calendar and try again.';

export const getCalendarSyncIssue = (response?: BackendResponse | null): CalendarSyncIssue | null => {
  if (!response) {
    return null;
  }

  const status = response.status;
  const bodyStatus = response.body?.status_code;
  const message = response.body?.message || response.body?.detail;

  if (status === 409 || bodyStatus === 409 || message === 'CALENDAR_NOT_CONNECTED') {
    return { code: 'CALENDAR_NOT_CONNECTED', message: NOT_CONNECTED_MESSAGE };
  }

  if (status === 502 || bodyStatus === 502 || message === 'CALENDAR_SYNC_FAILED') {
    return { code: 'CALENDAR_SYNC_FAILED', message: SYNC_FAILED_MESSAGE };
  }

  return null;
};

export const applyCalendarSyncIssue = async (
  response?: BackendResponse | null,
  options?: CalendarSyncIssueHandlerOptions,
): Promise<boolean> => {
  const issue = getCalendarSyncIssue(response);
  if (!issue) {
    return false;
  }

  options?.onMessage?.(issue.message);

  if (issue.code === 'CALENDAR_NOT_CONNECTED' && options?.onNotConnected) {
    await options.onNotConnected();
  }

  return true;
};
